import { Modal, Button } from "react-bootstrap";
import styles from "./Popup.module.css";

const Popup = ({children, ...props}) => {
    const { title } = props
    return (
        <Modal 
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      className={styles.modal}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          { title }
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="body-padding" >
        { children }
      </Modal.Body>
      <Modal.Footer>
        {props.footer || <Button className='btn-primary' onClick={props.onHide}>Close</Button>}
      </Modal.Footer>
    </Modal>
    )

}

export default Popup;